import { useWorkflowScheduleOccurrences } from '@/hooks'
import { WORKFLOW_SCHEDULE_OCCURRENCE_REASON_LABELS, type WorkflowScheduleOccurrenceFilters } from '@/types'
import { formatInTimeZone } from './scheduleFormat'

const FAILED_FILTER: WorkflowScheduleOccurrenceFilters = { status: 'Failed' }
const LATEST_ONLY = { skipCount: 0, maxResultCount: 1 }

interface Props {
  projectId: string
  scheduleId: string
  timeZoneId: string
}

export function ScheduleLatestFailure({ projectId, scheduleId, timeZoneId }: Props) {
  const { data } = useWorkflowScheduleOccurrences(projectId, scheduleId, FAILED_FILTER, LATEST_ONLY)
  const latest = data?.items[0]

  if (!latest) return null

  return (
    <div className="text-sm" data-testid="schedule-latest-failure">
      <p>
        <span className="font-semibold">Last failure: </span>
        {WORKFLOW_SCHEDULE_OCCURRENCE_REASON_LABELS[latest.reason] ?? latest.reason}
        {' '}({formatInTimeZone(latest.scheduledForUtc, timeZoneId)})
      </p>
      {latest.reasonDetail && <p className="break-words">{latest.reasonDetail}</p>}
    </div>
  )
}
